// extracted by mini-css-extract-plugin
export default {"Header__search":"Search_Header__search__IUsYH"};